import '../../scripts/common';
import 'animate.css/animate.css';

import '../../scripts/autosize';
import '../../scripts/animate';
import '../../scripts/picture';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Field from '../../components/base/Field';
import Share from '../../components/Share';
import PageScrollBtn from '../../components/simple/PageScrollBtn';
import ArticleMiniCard from '../../components/ArticleMiniCard';
import ArticlesMiniList from '../../components/ArticlesMiniList';
import Spinner from '../../components/base/Spinner';
import Radio from '../../components/base/Radio';
import Breadcrumbs from '../../components/base/Breadcrumbs';

// Carousel
import Carousel from '../../components/base/Carousel';
import Rating from '../../components/base/Rating';
import ProductCard from '../../components/ProductCard';
import ProductQuickView from '../../components/ProductQuickView';
import Popup from '../../components/base/Popup';
import breakpoints from '../../scripts/variables';
import { media } from '../../scripts/helpers';

import './css/style.css';

import product1 from '../../images/content/product_1.jpg';
import product2 from '../../images/content/product_2.jpg';
import product3 from '../../images/content/product_3.jpg';
import product4 from '../../images/content/product_4.jpg';
import product5 from '../../images/content/product_5.jpg';

import nameplate1 from '../../images/content/nameplate_1.jpg';
import nameplate2 from '../../images/content/nameplate_2.jpg';

$(() => {
    Header.create();
    Footer.create();
    Field.create();
    Spinner.create();
    Radio.create();
    Share.create();
    Breadcrumbs.create();
    initCarousel();
    Rating.create();
    initProductCard();
    initPopup();
    ArticleMiniCard.create();
    PageScrollBtn.create();
    ArticlesMiniList.create();
});

function initCarousel() {
    const productsSlidesCount = $('.swiper-slide', $('.carousel--products')).length;

    const carouselProductsObj = new Carousel($('.carousel--products'));
    carouselProductsObj.init(
        {
            reinitBreakpoints: [media('tabletLg')],
            reinitOptions: {
                default: {
                    loop: productsSlidesCount > 4,
                },
                [breakpoints.mobileLg - 1]: {
                    loop: productsSlidesCount > 2,
                },
                [breakpoints.tabletLg - 1]: {
                    loop: productsSlidesCount > 3,
                },
            },
        },
        {
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            slidesPerView: 4,
            loop: productsSlidesCount > 4,
            slideToClickedSlide: false,
            breakpoints: {
                [breakpoints.mobileLg - 1]: {
                    slidesPerView: 2,
                },
                [breakpoints.tabletLg - 1]: {
                    slidesPerView: 3,
                },
            },
        }
    );
}

const productImages = { product1, product2, product3, product4, product5 };
const productNameplates = { nameplatesProduct2: [nameplate1, nameplate2] };

/**
 * Инициализация карточек товара
 */
function initProductCard() {
    $('.product-card').each((i, item) => {
        const num = /\d/.test(item.id) ? item.id.match(/\d/)[0] : 1;
        const productDefault = new ProductCard($(item));
        productDefault.init({
            picture: productImages[`product${num}`],
            nameplates: productNameplates[`nameplatesProduct${num}`],
        });
    });

    ProductQuickView.create();
}

/**
 * Активация попапов
 */
function initPopup() {
    Popup.create();
}

const returnBtn = document.querySelector('.article-page__header-return');

returnBtn.addEventListener('click', evt => {
    evt.preventDefault();
    window.history.back();
});
